import React from 'react';

import { useSubscriptionContext } from 'contexts/SubscriptionContext';
import { Navigate, Outlet } from 'react-router-dom';
import { ROUTE_LINKS } from 'shared/constants/route-links';
import { ProductName } from 'shared/interfaces/Product';

const EXCLUDED_PATHS = [
  // Important to exclude paywall, otherwise we get an infinite redirect
  ROUTE_LINKS.paywall,
  ROUTE_LINKS.onboarding,
  ROUTE_LINKS.postLoginRouter,
  ROUTE_LINKS.postBillingSessionHandler,
  ROUTE_LINKS.subscriptionRedirectHandler
];

export const FreeAccountGuard = () => {
  const [subscription] = useSubscriptionContext();

  return subscription.product.name === ProductName.STARTER && !EXCLUDED_PATHS.includes(location.pathname) ? (
    <Navigate to={ROUTE_LINKS.paywall} />
  ) : (
    <Outlet />
  );
};
